import httpClient from "@plugins/http";
import { ApiResponse } from "@apis/api.ts";
import { DataTableOutput } from "@/plugins/common/types";
import { MoeRelatedVersion } from "@/types/lesson";

export default {
  reject: (uuid, params) =>
    httpClient.post(`/apis/moe-library/reject/${uuid}`, null, {
      params: params,
    }),

  unpublish: (uuid, params) =>
    httpClient.post(`/apis/moe-library/unpublish/${uuid}`, null, {
      params: params,
    }),

  duplicate: (requestData): Promise<ApiResponse<Map<string, string>>> => {
    return httpClient.post(`/apis/moe-library/duplicate/${requestData.moeLibraryUuid}`, null, {
      params: requestData,
    });
  },

  createWorkingCopy: (moeLibraryUuid: string): Promise<ApiResponse<string>> => {
    return httpClient.post(`/apis/moe-library/create-working-copy/${moeLibraryUuid}`);
  },

  delete: (params) => {
    const uuid = params.uuid;
    delete params.uuid;
    return httpClient.post(`/apis/moe-library/lesson/delete/${uuid}`, null, {
      params: params,
    });
  },

  checkIfSubmittable: (params): Promise<ApiResponse<never>> =>
    httpClient.get(`/apis/moe-library/submittable/${params.uuid}`, {
      params: params,
    }),

  checkIfApproveable: (params): Promise<ApiResponse<never>> =>
    httpClient.get(`/apis/moe-library/approvable/${params.uuid}`, {
      params: params,
    }),

  submit: async (params): Promise<ApiResponse<object>> => {
    return await httpClient.post(`/apis/moe-library/submit/${params.uuid}`, params.requestData);
  },

  approve: async (params): Promise<ApiResponse<object>> => {
    return await httpClient.post(`/apis/moe-library/approve/${params.uuid}`, params.requestData);
  },
  fetchMOELesson: (params) => {
    const uuid = params.uuid;
    delete params.uuid;
    return httpClient.get(`/apis/moe-library/lesson/${uuid}`, {
      params: params,
    });
  },
  fetchMOELessonRelatedVersion: (lessonUuid) => {
    return httpClient.get(`/apis/moe-library/lesson/related-version/${lessonUuid}`);
  },
  fetchMOELessonContext: (lessonUuid) => {
    return httpClient.get(`/apis/moe-library/lesson/get-context/${lessonUuid}`);
  },
  /**
   * Use when
   * - create new lesson with ALP template
   */
  createMOELessonWithTemplate: (
    templateUuid,
    title,
    activitiesToDuplicate,
    sectionsToDuplicate,
    ownerGroupId,
  ) => {
    const params = new URLSearchParams();
    params.append("templateUuid", templateUuid);
    params.append("title", title);
    params.append("activitiesToDuplicate", activitiesToDuplicate ?? []);
    params.append("sectionsToDuplicate", sectionsToDuplicate ?? []);
    params.append("ownerGroupId", ownerGroupId);
    return httpClient.post(`/apis/moe-library/lesson/create/with-template?${params}`);
  },
  createMOELessonWithSourceLesson: (
    sourceLessonUuid,
    activitiesToDuplicate,
    sectionsToDuplicate,
    ownerGroupId,
  ) => {
    const formData = new FormData();
    formData.append("lessonUuid", sourceLessonUuid);
    formData.append("activitiesToDuplicate", activitiesToDuplicate ?? []);
    formData.append("sectionsToDuplicate", sectionsToDuplicate ?? []);
    formData.append("ownerGroupId", ownerGroupId);
    return httpClient.post(`/apis/moe-library/lesson/create/with-source-lesson`, formData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  },
  createMOELesson: (learningType, title, courseCreationOption, ownerGroupId) => {
    const params = new URLSearchParams();
    params.append("learningType", learningType);
    params.append("title", title);
    params.append("courseCreationOption", courseCreationOption);
    params.append("ownerGroupId", ownerGroupId);
    return httpClient.post(`/apis/moe-library/lesson/create?${params}`);
  },

  edit: (params) => {
    const uuid = params.uuid;
    delete params.uuid;
    return httpClient.post(`/apis/moe-library/lesson/edit/${uuid}`, null, {
      params: params,
    });
  },
  fetchMOERelatedVersionsList: (
    lessonUuid: string,
  ): Promise<ApiResponse<DataTableOutput<MoeRelatedVersion>>> => {
    return httpClient.get(`/apis/moe-library/lesson/related-versions/${lessonUuid}`);
  },
};
